function SearchPubsController($scope, Publication) {
  $scope.publications = {
    search: $scope.publicationName
  };

  $scope.selectPublication = ($item) => {
    $scope.update({
      id: $item.id,
      name: $item.name,
      website: $item.website,
      active: true
    });
    $scope.publications.search = $scope.clearOnSelection ? '' : $scope.publications.search;
    $scope.results = [];
  };

  $scope.onChange = () => {
    const pitchedPublicationIds = $scope.excluded || [];

    $scope.results = [];

    Publication.getPublicationsList({ nameRegex: $scope.publications.search, website: $scope.site })
      .then((data) => {
        $scope.results = data.publications.reduce((acc, pub) => {
          if (!pitchedPublicationIds.some(id => id === pub.id)) {
            acc.push({
              active: false,
              name: pub.name,
              id: pub.id
            });
          }
          return acc;
        }, []);
      });
  };
}

const controllerArray = [
  '$scope',
  'Publication',
  SearchPubsController
];

export default function (ngModule) {
  ngModule.controller('SearchPubsController', controllerArray);
}
